module.exports = __webpack_public_path__ + "static/media/attention.40fcf148.svg";